import { useEffect, useState } from "react";
import { getDefaultDevcontainer } from "../api/devcontainer";
import { defaultDevcontainerIdOf } from "../types/defaultDevcontainer";

// The caller's Default Devcontainer id, read once when the picker mounts; null while loading, when there is none, or when the read fails.
export function useDefaultDevcontainerId(): string | null {
  const [id, setId] = useState<string | null>(null);
  useEffect(() => {
    let cancelled = false;
    getDefaultDevcontainer()
      .then((record) => { if (!cancelled) setId(defaultDevcontainerIdOf(record) ?? null); })
      .catch(() => { if (!cancelled) setId(null); });
    return () => { cancelled = true; };
  }, []);
  return id;
}
